var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"lost-view"}},[_c('h1',[_vm._v("Page Not Found")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home.")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }